module.exports = __webpack_public_path__ + "img/photo.5b4d81b7.svg";